import { useMemo, useSyncExternalStore } from 'react';
import { CopilotChannelContext } from './CopilotChannelContext';
import { createCopilotChannel } from './createCopilotChannel';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotChannelProvider = ({
  children,
  createLayer,
  instanceId
}) => {
  const channel = useMemo(() => createCopilotChannel({
    createLayer,
    instanceId
  }), [createLayer, instanceId]);
  const subscribe = useMemo(() => {
    // Because this is stored on the window we have to make this backwards
    // compatible and check that it exists
    if (channel && typeof channel.addStateListener === 'function') {
      return channel.addStateListener;
    }
    return () => () => {};
  }, [channel]);
  const getState = useMemo(() => {
    // Because this is stored on the window we have to make this backwards
    // compatible and check that it exists
    if (channel && typeof channel.getState === 'function') {
      return channel.getState;
    }
    const defaultState = {
      appContext: {},
      isFileManagerOpen: false,
      isNavCopilotAvailable: false,
      isWidgetOpen: false,
      isWidgetActive: false,
      layoutType: 'panel'
    };
    return () => defaultState;
  }, [channel]);
  const channelState = useSyncExternalStore(subscribe, getState);
  const contextValue = useMemo(() => ({
    channel,
    channelState,
    instanceId
  }), [channel, channelState, instanceId]);
  return /*#__PURE__*/_jsx(CopilotChannelContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default CopilotChannelProvider;